import { apiFuns } from "sw-hic";
let { genStandard, get } = apiFuns;

const api = {
  /*********** 床位 ***********/
  Bed: genStandard("bed", "/api/ip", false, true),
  Hospitalization: {
    ipNo: (ipNo) => get(`/api/ip/hospitalization/ipNo/${ipNo}`),
  },
};

export default api;
